module.exports = __webpack_public_path__ + "img/2.e09fd515.jpg";